module.exports = require('./StupDark')
